import React from 'react';
import { PRIMARY_BLUE } from '../../../Constants/Colors.constants';
import { BookingDialog } from '../EventPage/BookingDialog';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { makeStyles } from '~/UIKit/Style';
import { Route } from '~/Constants/Routes.constants';

export interface BookingComponentProps {
  eventName: string;
}

const useStyles = makeStyles({
  root: {},
  backButton: {
    color: PRIMARY_BLUE,
    paddingLeft: 15,
    paddingTop: 0,
    lineHeight: '52px',
    fontWeight: 'normal',
    '& svg': {
      fontWeight: 'bold',
      width: 42,
      height: 42,
      marginLeft: -15,
    },
  },
});

const BookingComponent = ({ eventName }: BookingComponentProps) => {
  const { classes } = useStyles();

  return (
    <PrivateLayout backRoute={Route.PROVIDER_DETAIL} title={eventName} actionName={' '}>
      <div className={classes.root}>
        <BookingDialog />
      </div>
    </PrivateLayout>
  );
};

export default BookingComponent;
